/** Absolute URLs only — relative t.me/... resolves on your own domain. */
export const TELEGRAM_CHANNEL_URL = 'https://t.me/jobsopportunityin';
